const c = (e, s, t, n) => {
    if (!e || !(s || t) || (s && typeof s != 'number')) return null;
    try {
      const o = new URL(e, window.location.origin),
        r = o.searchParams,
        i = r.get('width'),
        a = r.get('height'),
        l = r.get('crop');
      return (
        !t && a && r.delete('height'),
        !s && i && r.delete('width'),
        !n && l && r.delete('crop'),
        s && r.set('width', s),
        o.href
      );
    } catch {
      return null;
    }
  },
  w = [165, 360, 533, 720, 940, 1066],
  C = new Set(
    [
      'accessories',
      'backpacks',
      'bag',
      'bag strap',
      'bags',
      'belts',
      'boots',
      'bracelets & bangles',
      'brooch',
      'brooches',
      'duffle',
      'earrings',
      'flats',
      'footwear',
      'hats',
      'heel',
      'heels',
      'jewellery',
      'large bag',
      'large bags',
      'large handbags',
      'leather',
      'leather bags',
      'loafer',
      'loafers',
      'mule',
      'mules',
      'necklace',
      'necklaces',
      'outlet boots',
      'outlet flats',
      'outlet heel',
      'outlet sneakers',
      'pump',
      'pumps',
      'ring',
      'rings',
      'sandals',
      'scarves',
      'shoe',
      'shoes',
      'slide',
      'slides',
      'small bag',
      'small bags',
      'small handbags',
      'sneakers',
      'sunglasses',
      'tote',
      'wallet',
      'wallets',
    ].map((e) => e.toLowerCase())
  );
function y(e) {
  const s = (e || '').trim().toLowerCase();
  return !!(s && C.has(s));
}
function h(e, s) {
  if (!e) return '';
  const t = [];
  for (const n of w) {
    if (s && n > s) continue;
    const o = c(e, n);
    o && t.push(`${o} ${n}w`);
  }
  if (s) {
    const n = c(e, s);
    n && !w.includes(s) && t.push(`${n} ${s}w`);
  }
  return t.join(', ');
}
function N() {
  var e;
  return ((e = document.querySelector('plp-image-toggle')) == null ? void 0 : e.dataset.currentView) === 'item'
    ? 'item'
    : 'model';
}
function F(e, s) {
  var o;
  if (!e) return;
  const t = new Image();
  'fetchPriority' in t && (t.fetchPriority = 'low'), (t.src = c(e, 533) || e);
  const n = h(e, s);
  n && ((t.srcset = n), (t.sizes = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw')),
    (o = t.decode) == null || o.call(t).catch(() => {});
}
function v(e, s, t, n, o = N(), r, i = n, a = r) {
  if (!e || !s) return;
  (e.dataset.modelImage = s),
    (e.dataset.clearcutImage = t || s),
    Number.isFinite(n) && (e.dataset.modelWidth = String(n)),
    Number.isFinite(r) && (e.dataset.modelHeight = String(r)),
    Number.isFinite(i) && (e.dataset.clearcutWidth = String(i)),
    Number.isFinite(a) && (e.dataset.clearcutHeight = String(a));
  const l = Number.isFinite(i) ? i : n,
    S = Number.isFinite(a) ? a : r,
    f = o === 'item' && t,
    u = f ? t : s,
    d = f ? l : n,
    g = f ? S : r,
    b = Number.isFinite(d) ? d : void 0,
    p = Number.isFinite(g) ? g : void 0;
  b && e.setAttribute('width', String(b)), p && e.setAttribute('height', String(p)), (e.src = c(u, 533) || u);
  const m = h(u, b);
  m ? e.setAttribute('srcset', m) : e.removeAttribute('srcset');
}
export {v as a, c as b, N as g, y as i, F as p};
